import React from 'react';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ImageUploading from 'react-images-uploading';
import { Link, useNavigate } from "react-router-dom";
import {useState, CSSProperties } from "react";
import { doExhibitorRegister } from '../../Service';
import Swal from "sweetalert2";
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faCircleExclamation} from '@fortawesome/free-solid-svg-icons';
import ClipLoader from "react-spinners/ClipLoader";

const override: CSSProperties = {
    display: "block",
    margin: "0 auto",
    borderColor: "#96D2CE",
  };

export default function AccountRegister(){
    const [loading, setLoading] = useState(false);
    const [color, setColor] = useState("#ffffff");
    const navigation = useNavigate();
    //const [date, setDate] = useState(new Date());
    const [images, setImages] = React.useState([]);
    const [formErrors, setFormErrors] = useState({});
    const initialValues = { name: "", address1: "", address2: "", city: "", state:"", country: "", phone: "", website: "", primary_contact_full_name: "", instagram: "", twitter: "", facebook: "",email: "", gallery_history: "", profile_image: "",user_role: 2};
    const [formValues, setFormValues] = useState(initialValues);
    const maxNumber = 69;

    
    
    const onChange = (imageList, addUpdateIndex) => {
        // data for submit
        //console.log(imageList, addUpdateIndex);
        setImages(imageList);
        const field1='profile_image';
        setFormValues(prevState => ({
            ...prevState,
            [field1]:  imageList[0]['file']
        }));
        
    };
    
    const hanldeChange = (e) => {
        const value=e.target.value;
        const field=e.target.name;
        setFormValues(prevState => ({
            ...prevState,
            [field]:  value  }));
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        const errorCount = validate(formValues);
        setFormErrors(errorCount);
        if(errorCount.status){
            doExhibitorRegister(formValues).then(res => handleResponse(res))
        }else{
            window.scrollTo(100, 100);
            setLoading(false);
			return false;
        }
    }

    const handleResponse = (response) => {
        if(response.data.code==200){
        Swal.fire({
            icon: 'success',
            text: 'Registered Successfully! Please wait for your Approval email',
        })
        setLoading(false);
          navigation("/Login");
        } else {
            
          const errors = {};
          errors.invalid = response.data.message;
          errors.status = false;
          setFormErrors(errors);
        }  
      }


    
    const validate = (values) => {
        const errors = {};
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
        const dot_regex = /^(?!.*\.\.|\.).*$/gm;
        const phone_regex= /^[+0-9]*$/i;
        const website_regex = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/i;
        const password_regex = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,}$/;

        errors.status = true;
        if(!values.name){
            errors.name = 'Gallery Name is required';
            errors.status = false;
        } 
        if(!values.address1){
            errors.address1 = 'Address 1 is required';
            errors.status = false;
        } 
        if(!values.city){
            errors.city = 'City is required';
            errors.status = false;
        } 
        if(!values.state){
            errors.state = 'State is required';
            errors.status = false;
        } 
        if(!values.country){
            errors.country = 'Country is required';
            errors.status = false;
        } 
        if(!values.phone){
            errors.phone = 'Phone is required';
            errors.status =false;
        } else if (values.phone && !phone_regex.test(values.phone)) {
            errors.phone = "Please enter a valid phone number!";
            errors.status = false;
        } 
        
        if (values.website && !website_regex.test(values.website)) {
            errors.website = "Please enter a valid website!";
            errors.status = false;
        }
        if(!values.primary_contact_full_name){
            errors.primary_contact_full_name = 'Primary Contact Name is required';
            errors.status = false;
        } /*else if(!values.instagram){
            errors.instagram = 'Instagram is required';
            error_val = 1;
        } else if(!values.twitter){
            errors.twitter = 'Twitter is required';
            error_val = 1;
        } else if(!values.facebook){
            errors.facebook = 'Facebook is required';
            error_val = 1;
        } */ 
        if(!dot_regex.test(values.email)) {
            errors.email = "This is not a valid email format!";
            errors.status = false;
        }

        if(!values.email){
            errors.email = 'Email is required';
            errors.status = false;
        } else if(!regex.test(values.email)) {
            errors.email = "This is not a valid email format!";
            errors.status = false;
        }

        if(!values.password){
            errors.password = 'Password is required';
            errors.status = false;
        } else if(values.password && !password_regex.test(values.password)) {
            errors.password = "Your password must have at least 8 characters, including at least 1 uppercase, 1 lowercase, 1 digit, and 1 special character";
            errors.status = false;
        }

        if(!values.gallery_history){
            errors.gallery_history = 'Gallery_history is required';
            errors.status = false;
        }
        if(images.length===0){
            errors.images = 'Profile Image is required';
            errors.status = false;
        }

        return errors;
    }

    const handleBackSubmit =(e) => {
        navigation('/login');
    }

    const renderTooltip = (props) => (
        <Tooltip id="button-tooltip" {...props}>
          Password must have at least 8 characters, including at least 1 uppercase, 1 lowercase, 1 digit, and 1 special character
        </Tooltip>
      );

 return(
    <section className="admin-section">
    <div className="container">
        <div className="row">
            <div className="col-md-12 col-12">
                <div className="admin-edit event-app">
{ 
    loading ?
            <ClipLoader color={color} loading={loading} cssOverride={override} size={250} />
        :
        <> 
                    <h1>Register</h1>
                    <p className="error">{formErrors.invalid}</p>
                    <Form> 
                            <Form.Group>
                                <Form.Label>Gallery Name <span className='star'>*</span></Form.Label>
                                <Form.Control type="text" name="name" onChange={hanldeChange} placeholder="Gallery Name" />
                                <p className="error">{formErrors.name}</p>
                            </Form.Group>
                          
                            <Row>
                            <Col>
                                <Form.Group>
                                    <Form.Label>Address <span className='star'>*</span></Form.Label>
                                    <Form.Control type="text" name="address1" onChange={hanldeChange} placeholder="Street Address" />
                                    <p className="error">{formErrors.address1}</p>
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group>
                                    <Form.Label>Address 2 </Form.Label>
                                    <Form.Control type="text" name="address2" onChange={hanldeChange} placeholder="Apt, Suite, Etc..." />
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row>
                            
                            <Col>
                                <Form.Group>
                                    <Form.Label>City <span className='star'>*</span></Form.Label>
                                    <Form.Control type="text" name="city" onChange={hanldeChange} placeholder="City" />
                                    <p className="error">{formErrors.city}</p>
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group>
                                    <Form.Label>State <span className='star'>*</span></Form.Label>
                                    <Form.Control type="text" name="state" onChange={hanldeChange} placeholder="State" />
                                    <p className="error">{formErrors.state}</p>
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group>
                                    <Form.Label>Country<span className='star'>*</span></Form.Label>
                                    <Form.Control type="text" name="country" onChange={hanldeChange} placeholder="Country" />
                                    <p className="error">{formErrors.country}</p>
                                </Form.Group>
                            </Col>
                        </Row>
 
                        <Row>
                            <Col>
                                <Form.Group>
                                    <Form.Label>Phone Number<span className='star'>*</span></Form.Label>
                                    <Form.Control type="text" minLength={10} maxLength={10} name="phone" onChange={hanldeChange} placeholder="Phone Number" />
                                    <p className="error">{formErrors.phone}</p>
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group>
                                    <Form.Label>Website </Form.Label>
                                    <Form.Control type="text" name="website" onChange={hanldeChange} placeholder="Website" />
                                    <p className="error">{formErrors.website}</p>
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <Form.Group>
                                    <Form.Label>Primary Contact Full Name<span className='star'>*</span></Form.Label>
                                    <Form.Control type="text" name="primary_contact_full_name" placeholder="Primary Contact Full Name" onChange={hanldeChange}/>
                                    <p className="error">{formErrors.primary_contact_full_name}</p>
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group>
                                    <Form.Label>Instagram Handle </Form.Label>
                                    <Form.Control type="text" name="instagram"  placeholder="@Instagram" onChange={hanldeChange}/>
                                    <p className="error">{formErrors.instagram}</p>
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <Form.Group>
                                    <Form.Label>Twitter Handle</Form.Label>
                                    <Form.Control type="text" name="twitter"   placeholder="@Twitter" onChange={hanldeChange}/>
                                    <p className="error">{formErrors.twitter}</p>
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group>
                                    <Form.Label>Facebook</Form.Label>
                                    <Form.Control type="text" name="facebook" placeholder="Facebook" onChange={hanldeChange}/>
                                    <p className="error">{formErrors.facebook}</p>
                                </Form.Group>
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                <Form.Group>
                                    <Form.Label>Email<span className='star'>*</span></Form.Label>
                                    <Form.Control type="email" name="email"   placeholder="Email" onChange={hanldeChange}/>
                                    <p className="error">{formErrors.email}</p>
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group>
                                    <Form.Label>Please Create Password<span className='star'>*<OverlayTrigger
      placement="right"
      delay={{ show: 250, hide: 400 }}
      overlay={renderTooltip}
    >
      
        <FontAwesomeIcon icon={faCircleExclamation} style={{"color":"black", "margin-left":"5px"}}   variant="info"/>
      
    </OverlayTrigger></span></Form.Label>
                                    <Form.Control type="password" name="password" placeholder="Please Create Password" onChange={hanldeChange}/>
                                    <p className="error">{formErrors.password}</p>
                                </Form.Group>
                            </Col>
                        </Row>

                        

                        <Form.Group>
                            <Form.Label>Describe the history of your gallery <span className='star'>*</span></Form.Label>
                            <Form.Control as="textarea" name="gallery_history" rows={3} placeholder="Gallery History" onChange={hanldeChange}/>
                            <p className="error">{formErrors.gallery_history}</p>
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>Profile Image <span className='star'>*</span></Form.Label>
                            <p>
                                <i>This image will represent your gallery on the fair landing page. 
                                Images will be cropped to 3:2 (4x6) aspect ratio</i>
                            </p>
                            <p>
                                File Specifications: jpg, sRGB, 72 dpi, less than or equal to 2MB
                                File names cannot contain any apostrophes or special characters .
                            </p>
                            <ImageUploading  value={images} onChange={onChange} maxNumber={maxNumber} dataURLKey="data_url">
                                {({
                                imageList,
                                onImageUpload,
                                onImageRemoveAll,
                                onImageUpdate,
                                onImageRemove,
                                isDragging,
                                dragProps,
                                }) => (
                                // write your building UI
                                <div className="choose-file">
                                    <button type='button'
                                    style={isDragging ? { color: 'red' } : undefined}
                                    onClick={onImageUpload}
                                    {...dragProps}
                                    >
                                    <img src={process.env.PUBLIC_URL+'/images/crop-image.png'}/>
                                    </button>
                                    <p>File Specifications: jpg, sRGB, 2MB note: images will be cropped as square</p>
                                    <p className="error">{formErrors.images}</p>
                                    {imageList.map((image, index) => (
                                    <div key={index} className="image-item">
                                        <img src={image['data_url']} alt="" width="100" />
                                        <div className="image-item__btn-wrapper">
                                        {/* <button type='button' onClick={() => onImageUpdate(index)}>Update</button>
                                        <button type='button' onClick={() => onImageRemove(index)}>Remove</button> */}
                                        </div>
                                    </div>
                                    ))}
                                </div>
                                )}
                        </ImageUploading>
                        </Form.Group>
                        <hr/>
                        <div className='text-center'>
                        <Button variant="submit" className='common-btn' onClick={handleSubmit}>Next</Button>{' '}
                        <Button variant="outline-secondary" onClick={handleBackSubmit} className='cancel-btn'>Back</Button>{' '}
                        </div>
                    </Form>
                    </>
            }
                </div>
            </div>
        </div>
    </div>
</section>
)
}